export const useLoyaltyPagination = async (endpoint: string, itemsPerPage: number = 10) => {
  const { isLoading } = useSetup()
  const results: Ref = ref(null);
  const currentPage = ref(1);

  try {
    results.value = await useAuthFetch(`${ endpoint }?page=1&pageSize=${ itemsPerPage }`, { strategy: 'aminess' });
  } catch(e) {
  }

  async function fetchResults(type = 'next', page: number) {
    if (page) currentPage.value = page;
    else if (type === 'next') currentPage.value++;
    else if (currentPage.value > 1) currentPage.value--;

    try {
      const response = await useAuthFetch(`${ endpoint }?page=${ currentPage.value }&pageSize=${ itemsPerPage }&pagingCookie=${ results.value.pagingCookie }`, { strategy: 'aminess' });
      results.value = response;
    } catch(e) {}
  }

  return {
    results,
    currentPage,
    fetchResults,
  }
}